const clientEventType = {
    CLIENT_AUDIO_REWIND: 'client_audio_rewind',
    CLIENT_RESOURCE_LOAD_TIMEOUT: 'client_resource_load_timeout',
    IDLE: 'idle',
    ISEB_DEVICE_SECURITY_VIOLATION: 'iseb_device_security_violation',
    SEB_EXIT: 'seb_exit',
    SECTION_AUDIO_INTERACTED: 'section_audio_interacted',
    SERVER_ERROR: 'server_error',
    TIMED_OUT: 'timed_out',
};

export default clientEventType;
